// import CarAdd from "pages/cars/CarAdd";
import InDevelop from "components/InDevelop";
// import { NotFoundBlock } from "components/NotFoundBlock";
import { SSO } from "components/SSO";
import Home from "pages/Home";

import ErrorPage from "pages/error-page";
import MainPage from "pages/main/MainPage";
import { SettingsBody } from "pages/settings/SettingsBody";

import { createBrowserRouter } from "react-router-dom";

export const routerStruct = {
  children: [
    {
      element: <MainPage />,
      path: "/",
    },

    {
      element: <SettingsBody />,
      path: "settings",
    },

    {
      element: <ErrorPage />,
      path: "404",
    },
    {
      element: <SSO />,
      path: "silent-check-sso",
    },
  ],
  element: <Home />,
  errorElement: <ErrorPage />,
  path: "",
};
export const router = createBrowserRouter([routerStruct]);
